(function () {
    'use strict';
    var m = angular.module('gui-v2');
    m.directive('profileEventLog', ["path", function (path) {
        return {
            restrict: 'A',
            replace: false,
            templateUrl: path('gui-v2').directive('profile/common/event-log').template('event-log'),
            scope: {},
            link: function ($scope, element, attrs) {
                $scope.panel = {
                    type: 'data-table',
                    logic: {
                        name: 'fileEventsListLogic',
                        timeColumnName: 'updated_at',
                        descriptionColumn: 'event',
                        idColumn: 'id',
                        imageColumn: 'name',
                        noTypes: true,
                        noEvents: true
                    },
                    size: 'col-lg-12 col-md-12 col-sm-12 col-xm-12',
                    bodyStyle: { height: '415px' },
                    class: 'light',
                    wrapper: {
                        type: 'widget-panel',
                        title: 'Live event log',
                        class: 'avanan white-body overflow-auto'
                    },
                    options: {
                        pagesAround: 2,
                        pageSize: 100000,
                        pagination: { page: 1 }
                    },
                    columns: [
                        {
                            id: 'id',
                            hidden: true,
                            description: 'Metacolumn that not exist in sql, used for dynamic rows'
                        },
                        {
                            id: 'updated_at',
                            text: 'Date/time',
                            format: 'time',
                            class: 'one-line-date'
                        },
                        {
                            id: 'name',
                            text: 'Actor'
                        },
                        {
                            id: 'event',
                            text: 'Event',
                            dataClass: 'cell-div-width-100'
                        }
                    ]
                };
            }
        };
    }]);
}());